<app-base-action-modal
  modalTitle="Add a Designated Unit"
  i18n-modalTitle
  primaryLabel="Continue"
  i18n-primaryLabel
  secondaryLabel="Cancel"
  i18n-secondaryLabel
  (primaryClicked)="continue()"
  (closeClicked)="cancel()"
  (secondaryClicked)="cancel()">
  <div class="d-flex flex-column" [style.gap.rem]="2.5">
    <div class="paragraph-lg" i18n>Complete the required info to add a new Designated Unit to the plan.</div>
    <div class="d-flex flex-column" [style.gap.rem]="2">
      <app-create-designated-unit-general-details-about-section
        [formGroup]="formGroup.controls.generalDetails"
        [formSubmitted]="formSubmitted"
        [designatedUnitTypeDropdowns]="designatedUnitTypeDropdowns$ | async"
        [remittanceFrequencyDropdowns]="remittanceFrequencyDropdowns$ | async" />
      <hr class="m-0" />
      <app-create-designated-unit-general-details-effective-period-section
        [formGroup]="formGroup.controls.generalDetails"
        [formSubmitted]="formSubmitted" />
    </div>
  </div>
</app-base-action-modal>
